export default {
    init() {
        // JavaScript to be fired on the about us page
        this.imageFormat();
        this.pagination();
    },
    imageFormat() {
        jQuery('body:not(.attachment) main.main .entry-content p').each((index, element) => {
            const $item = jQuery(element);
            if ($item.children().length === 2 && jQuery('img', $item).length === 2) {
                $item.addClass('contains_images').addClass('row');
                $item.html($item.html().replace(/&nbsp;/g, ''));
                jQuery('img', $item).addClass('img-full');
                $item.find('img').each((iIndex, image) => {
                    jQuery(image).wrap('<div class="image col-12 col-md-6"></div>');
                });
            } else if ($item.children().length === 1 && jQuery('img', $item).length === 1) {
                $item.addClass('contains_images').addClass('row');
                $item.html($item.html().replace(/&nbsp;/g, ''));
                $item.find('img').each((iIndex, image) => {
                    jQuery(image).addClass('img-full');
                    jQuery(image).wrap('<div class="image col-12"></div>');
                });
            }
        });
    },
    pagination() {
        const container = '#posts-container';
        const button = '.nav-links .nav-previous a';
        jQuery(document).on('click', button, (e) => {
            e.preventDefault();
            const $this = jQuery(e.currentTarget);
            $this.addClass('disabled');
            jQuery.get($this.attr('href'), (data) => {
                jQuery(container).append(jQuery(`${container} article`, data));
                if (jQuery(button, data).length < 1) {
                    $this.remove();
                } else {
                    $this.removeClass('disabled');
                    $this.attr('href', jQuery(button, data).attr('href'));
                }
            });
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/Posts.js